import React from 'react';
import { ENVIRONMENT_OPTIONS } from '../aiModelConstants';
import { parseTags } from '../aiModelForm';
import { Field, inputClass } from '../aiModelUi';
import { StepProps } from './stepTypes';

const ModelInfoStep: React.FC<StepProps & { onNameChange: (name: string) => void }> = ({
  form,
  isLight,
  errors,
  patch,
  onNameChange,
}) => {
  return (
    <div className="space-y-3">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <Field label="Name" error={errors.name} isLight={isLight}>
          <input
            value={form.name}
            onChange={(e) => onNameChange(e.target.value)}
            placeholder="Fraud Detection"
            className={inputClass(isLight, Boolean(errors.name))}
          />
        </Field>
        <Field label="Code" hint="Stable identifier for workflows" error={errors.code} isLight={isLight}>
          <input
            value={form.code}
            onChange={(e) => patch({ code: e.target.value })}
            placeholder="fraud-detection"
            className={`${inputClass(isLight, Boolean(errors.code))} font-mono`}
          />
        </Field>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        <Field label="Version" error={errors.version} isLight={isLight}>
          <input
            value={form.version}
            onChange={(e) => patch({ version: e.target.value })}
            placeholder="v8.2"
            className={inputClass(isLight, Boolean(errors.version))}
          />
        </Field>
        <Field label="Environment" isLight={isLight}>
          <select
            value={form.environment}
            onChange={(e) => patch({ environment: e.target.value as typeof form.environment })}
            className={inputClass(isLight)}
          >
            {ENVIRONMENT_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </Field>
        <Field label="Owner" isLight={isLight}>
          <input
            value={form.owner}
            onChange={(e) => patch({ owner: e.target.value })}
            placeholder="Risk Platform"
            className={inputClass(isLight)}
          />
        </Field>
      </div>
      <Field label="Description" isLight={isLight}>
        <textarea
          value={form.description}
          onChange={(e) => patch({ description: e.target.value })}
          rows={2}
          placeholder="Detect fraudulent card transactions"
          className={inputClass(isLight)}
        />
      </Field>
      <Field label="Tags" hint="Comma-separated" isLight={isLight}>
        <input
          value={form.tags.join(', ')}
          onChange={(e) => patch({ tags: parseTags(e.target.value) })}
          placeholder="payments, risk, realtime"
          className={inputClass(isLight)}
        />
      </Field>
    </div>
  );
};

export default ModelInfoStep;
